module.exports = __webpack_public_path__ + "static/SY-ali-ecc67d09c2adf247f6344dee4f1e22dd.jpg";